import {
  CustomText,
  Figure,
  FigureType,
  ITEM_TYPES,
  ItemType,
  ParameteredText,
  SubtitlesItem,
  TitleItem,
} from "../types";

const findFigureTextItem = (
  figure: Figure | undefined,
  id: string | undefined
): { text: ParameteredText; figureType: FigureType } | undefined => {
  if (!figure || !id) return undefined;
  if (figure.number.id === id) {
    return { text: figure.number, figureType: "number" };
  }
  if (figure.units) {
    return { text: figure.units, figureType: "units" };
  }
  return undefined;
};

export const getCurrentTextItem = ({
  currentItem,
  titleStyle,
  textStyle,
  customTexts,
  parameteredTexts,
  figure,
}: {
  currentItem: ItemType | undefined;
  titleStyle: TitleItem;
  textStyle: SubtitlesItem;
  customTexts: CustomText[];
  parameteredTexts: ParameteredText[] | undefined;
  figure?: Figure;
}) => {
  if (currentItem?.type === ITEM_TYPES.Title) {
    return titleStyle;
  } else if (currentItem?.type === ITEM_TYPES.Subtitles) {
    return textStyle;
  } else if (currentItem?.type === ITEM_TYPES.CustomText) {
    const customText = customTexts.find((text) => text.id === currentItem.id);
    if (customText) {
      return customText;
    }
    const parameteredText = parameteredTexts?.find(
      (text) => text.id === currentItem.id
    );
    if (parameteredText) {
      return parameteredText;
    }
    const figureMatch = findFigureTextItem(figure, currentItem.id);
    if (figureMatch) {
      return figureMatch.text;
    }
  }
};

export const getCurrentTextAction = ({
  currentItem,
  setTitleStyle,
  setTextStyle,
  updateCustomText,
  updateParameteredText,
  updateFigure,
  customTexts,
  parameteredTexts,
  figure,
}: {
  currentItem: ItemType | undefined;
  setTitleStyle: (params: Partial<TitleItem>) => void;
  setTextStyle: (params: Partial<SubtitlesItem>) => void;
  updateCustomText: (params: Partial<CustomText>) => void;
  updateParameteredText: (params: Partial<ParameteredText>) => void;
  updateFigure: (
    params: Partial<ParameteredText>,
    figureType: FigureType
  ) => void;
  customTexts: CustomText[];
  parameteredTexts: ParameteredText[] | undefined;
  figure?: Figure;
}) => {
  if (currentItem?.type === ITEM_TYPES.Title) {
    return setTitleStyle;
  } else if (currentItem?.type === ITEM_TYPES.Subtitles) {
    return setTextStyle;
  } else if (currentItem?.type === ITEM_TYPES.CustomText) {
    const customText = customTexts.find((text) => text.id === currentItem.id);
    if (customText) {
      return (params: Partial<CustomText>) => {
        updateCustomText({
          id: currentItem.id,
          ...params,
        });
      };
    }
    const parameteredText = parameteredTexts?.find(
      (text) => text.id === currentItem.id
    );
    if (parameteredText) {
      return (params: Partial<ParameteredText>) => {
        updateParameteredText({
          id: currentItem.id,
          ...params,
        });
      };
    }
    const figureMatch = findFigureTextItem(figure, currentItem.id);
    if (figureMatch) {
      return (params: Partial<ParameteredText>) => {
        updateFigure({ id: currentItem.id, ...params }, figureMatch.figureType);
      };
    }
  }
};
